module.exports = __webpack_public_path__ + "static/media/goggles.90c866b6.svg";